// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RoundedVideo {
  flex-direction: column;
  align-items: flex-start;
}

.RoundedVideo-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  padding-top: 100px;
  padding-bottom: 60px;

  @media screen and (max-width: 1024px) {
    flex-direction: column;
    align-items: baseline;
    padding-bottom: 18px;
  }
}

.RoundedVideo-video {
  position: relative;
  width: 100%;
  height: 660px;
}

lite-youtube,
.RoundedVideo-video iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 32px;
  transition: opacity 0.4s ease-in-out;
}

lite-youtube.hidden {
  opacity: 0;
  pointer-events: none;
}

.rounded-video-iframe {
  opacity: 0;
  z-index: 1;
}

.rounded-video-iframe.loaded {
  opacity: 1;
  z-index: 2;
}

/* Responsive heights */
@media screen and (max-width: 1409px) {
  .RoundedVideo-video { height: 580px; }
}
@media screen and (max-width: 1129px) {
  .RoundedVideo-video { height: 500px; }
}
@media screen and (max-width: 1024px) {
  .RoundedVideo-video { height: 380px; }
}
@media screen and (max-width: 480px) {
  .RoundedVideo-video { height: 202px; }
}
`, "",{"version":3,"sources":["webpack://./src/css/RoundedVideo.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;;EAEpB;IACE,sBAAsB;IACtB,qBAAqB;IACrB,oBAAoB;EACtB;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;AACf;;AAEA;;EAEE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,UAAU;AACZ;;AAEA,uBAAuB;AACvB;EACE,sBAAsB,aAAa,EAAE;AACvC;AACA;EACE,sBAAsB,aAAa,EAAE;AACvC;AACA;EACE,sBAAsB,aAAa,EAAE;AACvC;AACA;EACE,sBAAsB,aAAa,EAAE;AACvC","sourcesContent":[".RoundedVideo {\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n.RoundedVideo-title {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  align-self: stretch;\n  padding-top: 100px;\n  padding-bottom: 60px;\n\n  @media screen and (max-width: 1024px) {\n    flex-direction: column;\n    align-items: baseline;\n    padding-bottom: 18px;\n  }\n}\n\n.RoundedVideo-video {\n  position: relative;\n  width: 100%;\n  height: 660px;\n}\n\nlite-youtube,\n.RoundedVideo-video iframe {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border-radius: 32px;\n  transition: opacity 0.4s ease-in-out;\n}\n\nlite-youtube.hidden {\n  opacity: 0;\n  pointer-events: none;\n}\n\n.rounded-video-iframe {\n  opacity: 0;\n  z-index: 1;\n}\n\n.rounded-video-iframe.loaded {\n  opacity: 1;\n  z-index: 2;\n}\n\n/* Responsive heights */\n@media screen and (max-width: 1409px) {\n  .RoundedVideo-video { height: 580px; }\n}\n@media screen and (max-width: 1129px) {\n  .RoundedVideo-video { height: 500px; }\n}\n@media screen and (max-width: 1024px) {\n  .RoundedVideo-video { height: 380px; }\n}\n@media screen and (max-width: 480px) {\n  .RoundedVideo-video { height: 202px; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
